import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { ArticleCard } from "@/components/ArticleCard";

export function RelatedArticles({ articleId }) {
  const [items, setItems] = useState([]);

  useEffect(() => {
    if (!articleId) return;
    api.get(`/articles/${articleId}/related`).then(({ data }) => setItems(data)).catch(() => setItems([]));
  }, [articleId]);

  if (items.length === 0) return null;

  return (
    <section className="mt-16 w-screen relative left-1/2 right-1/2 -ml-[50vw] -mr-[50vw] bg-[#10243A] px-4 sm:px-6 lg:px-8 py-12" data-testid="related-articles">
      <div className="max-w-3xl mx-auto">
        <h3 className="font-sans text-xs font-bold uppercase tracking-[0.2em] text-[#C47A35] mb-6">Още по темата</h3>
        <div className="divide-y divide-white/10">
          {items.map((a) => <ArticleCard key={a.id} article={a} variant="compact" dark />)}
        </div>
      </div>
    </section>
  );
}
